import DateMixin from './DateMixin';

export default {
  mixins: [DateMixin],
  methods: {
    setInitialDate(prop = 'MaxCreatedAt') {
      this.payload[prop] = this.formatDate(new Date());
    },
    handleDateByInterval(interval, maxProp = 'MaxCreatedAt', minProp = 'MinCreatedAt') {
      switch (interval) {
        case 'Weekly':
          return this.setWeeklyDate(maxProp, minProp);
        case 'Biweekly':
          return this.setBiweeklyDate(maxProp, minProp);
        case 'Monthly':
          return this.setMonthlyDate(maxProp, minProp);
        case 'Bimonthly':
          return this.setBimonthlyDate(maxProp, minProp);
        default:
          return this.setQuarterlyDate(maxProp, minProp);
      }
    },
    setWeeklyDate(maxProp, minProp) {
      this.handleMaxCreated(1, 'week', maxProp, minProp);
    },
    setBiweeklyDate(maxProp, minProp) {
      this.handleMaxCreated(2, 'weeks', maxProp, minProp);
    },
    setMonthlyDate(maxProp, minProp) {
      this.handleMaxCreated(1, 'month', maxProp, minProp);
    },
    setBimonthlyDate(maxProp, minProp) {
      this.handleMaxCreated(2, 'months', maxProp, minProp);
    },
    setQuarterlyDate(maxProp, minProp) {
      this.handleMaxCreated(3, 'months', maxProp, minProp);
    },
    handleMaxCreated(qtd, type, maxProp, minProp) {
      this.payload[minProp] = this.subtractDate(qtd, type, maxProp);
    },
    subtractDate(num, type, prop) {
      return this.formatDate(
        this.subtractIn(
          this.payload[prop],
          num,
          type,
        ),
      );
    },
  },
};
